// Ensures anonymous player session identity exists for the app runtime.

import { useEffect } from 'react';
import { getOrCreateSessionId } from '../utilities/cookies';

export const usePlayerSession = () => {
  useEffect(() => {
    getOrCreateSessionId();
  }, []);
};
